export default {
    /**
   * Scroll an element into view
   */
    scrollIntoView (id, args = {}) {
        document.getElementById(id)?.scrollIntoView(args);
    }
};
